import React from 'react';
import PropTypes from 'prop-types';
import InputGroupV2 from '../InputGroupV2';
import InputFormatV2 from '../InputFormatV2';
import moment from 'moment';

const getErrorMessage = (isRequired, value, onlyYear) => {
  if (!value && isRequired) return 'O campo é obrigatório';
  if (value) return moment(value, onlyYear ? 'YYYY' : 'MM/YYYY', true).isValid();
  return 'Informação inválida';
};

const YearMonthPickerV2 = ({
  value,
  onChange,
  label,
  disabled,
  error,
  isRequired,
  onlyYear = false,
}) => {
  const getDisplayValue = () => {
    if (!value) return '';

    const format = onlyYear ? 'YYYY' : 'MM/YYYY';

    if (typeof value === 'number') {
      const date = moment(value);
      if (date.isValid()) {
        return date.format(format);
      }
    }

    const date = moment(value, format, true);
    if (date.isValid()) {
      return date.format(format);
    }

    return value;
  };

  const handleInputChange = (event) => {
    const { value: rawValue } = event.target;
    const digits = rawValue.replace(/\D/g, '');

    if (!onlyYear && digits.length > 0) {
      const firstDigit = parseInt(digits[0], 10);

      if (firstDigit > 1) {
        onChange('');
        return;
      }

      if (digits.length === 2 && firstDigit === 1) {
        const secondDigit = parseInt(digits[1], 10);
        if (secondDigit > 2) {
          onChange(digits[0]);
          return;
        }
      }

      if (digits.length === 2 && firstDigit === 0) {
        const secondDigit = parseInt(digits[1], 10);
        if (secondDigit === 0) {
          onChange(digits[0]);
          return;
        }
      }
    }

    const format = onlyYear ? 'YYYY' : 'MM/YYYY';
    if (digits.length === (onlyYear ? 4 : 6)) {
      const parsed = moment(rawValue, format, true);
      if (parsed.isValid()) {
        onChange(parsed.valueOf());
      }
    } else {
      onChange(rawValue);
    }
  };

  const rawMsg = error ? getErrorMessage(isRequired, value, onlyYear) : '';
  const helperTextStr = typeof rawMsg === 'string' ? rawMsg : '';

  return (
    <InputGroupV2 label={label} isRequired={isRequired}>
      <InputFormatV2
        label={label}
        value={getDisplayValue()}
        onChange={handleInputChange}
        disabled={disabled}
        error={!!error}
        helperText={helperTextStr}
        format={onlyYear ? '####' : '##/####'}
        mask="_"
        showInputGroup={false}
      />
    </InputGroupV2>
  );
};

YearMonthPickerV2.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  isRequired: PropTypes.bool,
  onlyYear: PropTypes.bool,
};

YearMonthPickerV2.defaultProps = {
  disabled: false,
  error: false,
  isRequired: false,
  onlyYear: false,
};

export default YearMonthPickerV2;
